module.exports = __webpack_public_path__ + "img/bell.d99c74c8.svg";